export default __webpack_public_path__ + "static/media/reactEmployee.18af0374.png";